// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2LOCd","footer":"ModalInfo_footer__3cF6t"};